import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconVimeoStyle0 = cosmosIconCss;

const CosmosIconVimeo$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconVimeo extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '389894fbb21f4422edffc6b9b0bfb09e84beb250', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'a45ca2e6c10cc2e7cecfb24f3c6bd57b40bc1da8', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '3a7e718475ad8db89608787e9078f5632f16b6af', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.145 7.672c-.064 1.396-1.036 3.306-2.914 5.732-1.951 2.525-3.594 3.78-4.936 3.78-.839 0-1.501-.76-2.12-2.297-.38-1.413-.768-2.826-1.147-4.239-.433-1.545-.884-2.296-1.378-2.296a4.25 4.25 0 0 0-1.122.672l-.68-.883 2.093-1.864a4.636 4.636 0 0 1 2.12-1.29c1.112-.105 1.766.654 2.048 2.288.283 1.634.45 2.844.583 3.285.318 1.457.671 2.19 1.06 2.19.388 0 .75-.477 1.342-1.422.487-.64.828-1.378.998-2.163.088-.821-.23-1.228-.963-1.228a2.755 2.755 0 0 0-1.05.23c.677-2.302 2.007-3.417 3.991-3.347 1.466 0 2.155.99 2.075 2.852Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconVimeoStyle0; }
}, [1, "cosmos-icon-vimeo", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-vimeo"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-vimeo":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconVimeo$1);
            }
            break;
    } });
}

const CosmosIconVimeo = CosmosIconVimeo$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconVimeo, defineCustomElement };
